import React ,{useRef ,useEffect}from 'react';
import './evaluation-rate.scss'
import IrtizaDynamicInputList from '../irtiza-dynamic-input/irtiza-dynamic-input-list';
import moment from 'moment-timezone';
import SecurityService from '../security/security.service';
import EvaluationRateService from '../evaluation-rate/evaluation-rate.service';
import EvaluationRateAdd from './evaluation-rate-add';
import AuditTableInput from '../audit-table/audit-table'


const EvaluationRateInput = (props) => {

  // EvaluationRateID	
  // EvaluationDate	
  // EvaluationRateID	
  // OpeningExchangeRate	
  // AverageExchangeRate	
  // ClosingExchangeRate
    let columns =[
        {  field: "EvaluationRateID",headerText:'ID',width:'140px',textAlign:'right' ,headerTextAlign:'center',other:[]},
        {  field: "EvaluationDate",headerText:'Evaluation Date',width:'130px',textAlign:'right' ,headerTextAlign:'center',other:[]},
        {  field: "CurrencyName",headerText:'Currency',width:'130px',textAlign:'left' ,headerTextAlign:'center',other:[]},
        {  field: "OpeningExchangeRate",headerText:'Opening Exchange Rate',width:'160px',textAlign:'right' ,headerTextAlign:'center',other:[{'format':'n2'}]},
        {  field: "AverageExchangeRate",headerText:'Average Exchange Rate',width:'160px',textAlign:'right' ,headerTextAlign:'center',other:[{'format':'n2'}]},
        {  field: "ClosingExchangeRate",headerText:'Closing Exchange Rate',width:'160px',textAlign:'right' ,headerTextAlign:'center',other:[{'format':'n2'}]},
      ]

       const listActionComplete = (grid,args ,getListService ,selectedRow )=>{
        console.log(args )
        console.log(getListService )
        console.log(selectedRow )
        if (args.requestType === 'beginEdit' || args.requestType === 'add') {
          }
          if (args.requestType == 'save' || args.requestType == 'cancel' ) {
            getListService()
  
          }
          if(args.requestType == 'save'){
            console.log(args)


            function convertToMozambiqueTime(dateString) {
              // Parse the date string with the GMT offset
              const gmtDate = moment(dateString, "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
              
              // Convert the parsed date to Mozambique time zone (Africa/Maputo)
              const dateInMozambique = gmtDate.tz("Africa/Maputo").format('DD-MMM-YY');
              
              return dateInMozambique;
          }
          
            let data = {
               EvaluationRateID:args.data.EvaluationRateID,	
               EvaluationDate:convertToMozambiqueTime(args.data.EvaluationDate),	
               CurrencyID:args.data.CurrencyID,	
               CurrencyName:args.data.CurrencyName,
               OpeningExchangeRate:args.data.OpeningExchangeRate,	
               AverageExchangeRate:args.data.AverageExchangeRate,	
               ClosingExchangeRate:args.data.ClosingExchangeRate
            }
            console.log(data)
          if(args.action == 'add'){
            EvaluationRateService.insert(data).then(async (res)=>{
              await getListService()
              // let AddData = {
              //   UnitOfMeasurementID:args.data.UnitOfMeasurementID,
              //   UnitOfMeasurement:args.data.UnitOfMeasurement,
              // }
              // AuditTableInput.auditAdd(`UnitOfMeasurement`,`UnitOfMeasurement`,`UnitOfMeasurementID`,AddData)
            })
          }
          if(args.action == 'edit'){
            EvaluationRateService.update(data).then((res)=>{
              getListService()
  
              // let EditData = {
              //     UnitOfMeasurementID:args.data.UnitOfMeasurementID,
              //     UnitOfMeasurement:args.data.UnitOfMeasurement
              // }
              // let totalColumns = Object.keys(EditData);
              //             console.log(totalColumns)
              //             AuditTableInput.auditEdit(totalColumns,selectedRow,EditData,`UnitOfMeasurement`,args.data.MainUnitOfMeasurementID)
            })
          }
          }
          
       }
       //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************

        // Defines the  boolean
        // @default true
    let  allowTemplate = true
    let  allowGrouping = true
    let  allowExcelExport =true
    let  allowPdfExport = true
    let  showColumnChooser = true
    let  allowPaging = false
    let  allowDataBound = true
    let  allowGridSum = false

       
        // Defines the  string
        // @default EvaluationRate${typeMode} 
        let ListSecurity='CurrencyTransferList'
        let AddSecurity='CurrencyTransferAdd'
        let EditSecurity='CurrencyTransferEdit'
        let DeleteSecurity='CurrencyTransferDelete'
       
       // Defines the  ['Add','Edit','Delete','Update','Cancel','PDFExport','ExcelExport','Search','ColumnChooser'] | 'All'
       //  @default 'All'
      let toolbarOptions ='All';

      const toolbarClicking =  async (args)=>{
        console.log(args)
      }
      
       // Defines the 'Descending' | 'Ascending'
       //  @default 'Descending'
      let DefaultSortedColumnSort ='Descending';

       /* Defines the [{
                    TableName:'EvaluationRate' ,
                    TableID:'EvaluationRateID',
                   // Optional if Delete is Soft // TableSecurity:'EvaluationRateDelete',
                }]*/
    //  @default [] 
    //   let listDelete =  [{ TableName:'EvaluationRate' ,TableID:'EvaluationRateID', Optional // TableSecurity:'EvaluationRateDelete'}]
    let listDelete = [];
       
    // Defines 'Hard' | 'Soft' 
    // @Default 'Hard'
    let deleteType = 'Hard'


/* Defines the [   {field:'IsDeleted',
OPTIONAL HAI operator:'equal' or more check syncfusion documentation
        value:'No'},...more
        ] | []
      @default [] */
    //   let filterColumns = [{ field: 'IsDeleted', value: 'No' }];
      let filterColumns = [];

      /* Defines the [ColumnNames] | []
      @default [] */
    //   let groupColumns = ['IsDeleted','AccountTitleHawalaDr'];
      let groupColumns = [];

/* Defines the 'Dialog' | 'Normal'
      @default 'Dialog' */
      let gridEditSettingMode = 'Dialog';

/* Defines the '<p></p>' | Can give HTML | AND REACT FUNCTION LIKE HeaderTemplate
      @default '<p></p>' */
      let gridEditSettingHeaderTemplate = '<p></p>';

      /* Defines the  [ColumnNames] | []
      @default [] */
           //   let gridSumColumns = ['HawalaCommissionPercent'];
      let gridSumColumns = [];


    return (
        <IrtizaDynamicInputList
        Id='EvaluationRate'
        ListTitle='Evaluation Rate - List'
        ColumnsList={columns}
        GridDataSource= {[
                    {
                        DataSourceType: 'Function',
                        DataSource:  ()=> EvaluationRateService.getEvaluationRateForList()
                        }]}
        DefaultSortedColumnName={'EvaluationRateID'}
        GridDialog={[
            {
                DialogType:'Self',
                Dialog:<EvaluationRateAdd  />
                // Dialog:[
                //   {
                //     Title:'Invoice Evaluation',
                //     Inputs:[
                //       {field:{id:'MainInvoiceID',value:'InvoiceNo'},type:'dropdown',dataSource:{type:'Route',Route:'Invoice'},defaultValues:null},
                //       {field:{id:'EvaluationRateID',value:'EvaluationRateName'},type:'dropdown',dataSource:{type:'Route',Route:'EvaluationRateName'},defaultValues:null},
                //       {field:'ExchangeRate'	,type:'float',defaultValues:null},
                //       {field:'HawalaCommissionPercent'	,type:'float',defaultValues:null},
                //       {field:{id:'EvaluationRateIDHawala',value:'EvaluationRateNameHawala	'},type:'dropdown',dataSource:{type:'Route',Route:'EvaluationRateName'},defaultValues:null},
                //       {field:{id:'MainInvoiceID',value:'InvoiceNo'},type:'dropdown',dataSource:{type:'Route',Route:'Invoice'},defaultValues:null},
                //       {field:{id:'MainInvoiceID',value:'InvoiceNo'},type:'dropdown',dataSource:{type:'Route',Route:'Invoice'},defaultValues:null}
                //     ]
                //   }
                // ]

            }
        ]}
        ListActionComplete={listActionComplete}
        ToolbarClicking ={toolbarClicking}

        //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
            // AllowTemplate={allowTemplate}
            // ToolbarOption={toolbarOptions}
            // AllowGrouping={allowGrouping}
            // AllowExcelExport={allowExcelExport}
            // AllowPdfExport={allowPdfExport} 
            // ShowColumnChooser={showColumnChooser}
            // AllowPaging={allowPaging}
            AllowDataBound={allowDataBound}
            // ListSecurity={ListSecurity}
            // AddSecurity={AddSecurity}
            // EditSecurity={EditSecurity}
            // DeleteSecurity={DeleteSecurity}
            // DefaultSortedColumnSort={DefaultSortedColumnSort}
            // FilterColumns={filterColumns} /* IT USED WHEN GIVING FILTER IN GRID LIKE IsDeleted Column or more */
            // GroupColumns={groupColumns} 
            // ListDelete={listDelete}
            // DeleteType={deleteType} 
            // GridEditSettingMode={gridEditSettingMode}
            // GridEditSettingHeaderTemplate={gridEditSettingHeaderTemplate}
            // GridSumColumns={gridSumColumns}
            // AllowGridSum={allowGridSum}
            {...props}
            ></IrtizaDynamicInputList>
            
            );
}



export default EvaluationRateInput;
